<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.574"
      height="15.788"
      viewBox="0 0 21.574 15.788"
      class="scaling-svg"
    >
      <g id="Group_99" data-name="Group 99" transform="translate(-51 -512.212)">
        <g id="Icon_mail" transform="translate(51.483 516.038)">
          <path
            id="Shape"
            d="M15.3,12H1.7A1.709,1.709,0,0,1,0,10.285V1.714A1.709,1.709,0,0,1,1.7,0H15.3A1.709,1.709,0,0,1,17,1.714v8.571A1.709,1.709,0,0,1,15.3,12ZM1.7,2.725v6.7a.854.854,0,0,0,.85.857h11.9a.854.854,0,0,0,.85-.857v-6.7L8.5,7.011ZM3.3,1.714,8.5,4.989l5.2-3.275Z"
            transform="translate(-0.483 -0.038)"
            fill="#534d69"
          />
        </g>
        <g id="Group_16" data-name="Group 16" transform="translate(41.855 510.785)">
          <circle id="Oval" cx="6.146" cy="6.146" r="6.146" transform="translate(18.427 1.427)" fill="#534d69" />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M0,1.5,1.634,3.136,4.489,0"
            transform="translate(22.221 6.162)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.5"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class OneMailWithLinkIcon extends Vue {}
</script>

<style>
</style>
